import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-12 px-6 mt-20 border-t border-[#333]">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
        {/* About */}
        <div>
          <h3 className="font-bold text-xl mb-4">BankConvert</h3>
          <p className="text-sm text-white/80">
            Convert bank statements into clean, usable data instantly — CSV, Excel, or JSON.
          </p>
        </div>

        {/* Links */}
        <div>
          <h3 className="font-bold text-xl mb-4">Links</h3>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href="#why" className="hover:text-yellow-400 transition-colors">Why BankConvert</a></li>
            <li><a href="#inside" className="hover:text-yellow-400 transition-colors">What's Inside</a></li>
            <li><a href="#pricing" className="hover:text-yellow-400 transition-colors">Pricing</a></li>
            <li><a href="#faq" className="hover:text-yellow-400 transition-colors">FAQ</a></li>
          </ul>
        </div>

        {/* Connect */}
        <div>
          <h3 className="font-bold text-xl mb-4">Connect</h3>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href="mailto:support@bankconvert.com" className="hover:text-yellow-400 transition-colors">Email</a></li>
            <li><a href="https://twitter.com/bankconvert" target="_blank" rel="noreferrer" className="hover:text-yellow-400 transition-colors">Twitter</a></li>
            <li><a href="#cta" className="hover:text-yellow-400 transition-colors">Start Converting</a></li>
          </ul>
        </div>
      </div>

      {/* CTA Button */}
      <div className="mt-10 text-center">
        <a
          href="#cta"
          className="btn bg-white border-none text-[#FF7F4A] btn-lg gap-2"
        >
          Convert a Statement Now
        </a>
      </div>

      {/* Copyright */}
      <div className="mt-4 text-center text-sm text-white/70">
        © {new Date().getFullYear()} BankConvert
      </div>
    </footer>
  );
};

export default Footer;
